import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Box, Label } from 'fw/components';
import { Form, Multiselect } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

const items = {
	"1": "Ford",
	"2": "BMW",
	"3": "Porsche",
	"4": "Mercedes",
	"5": "VW",
	"6": "Ferrari",
	"7": "Peugeot",
	"8": "Lamborgini",
	"9": "Renault",
	"10": "Toyota"
};

const selection = () => {
	return ["1", "3", "4"]
}

class MultiselectDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: selection(),
				default: [],
				disabled: []
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="Mutliselect">
				<Form
					onSubmit={this.onSubmit}
					onChange={this.onChange}
					values={this.state.form}>
					<Row>
						<Col md={4}>
							<Label htmlFor="default">Default</Label>
							<Multiselect name="default" items={items} />
						</Col>
						<Col md={4}>
							<Label htmlFor="default">Disabled</Label>
							<Multiselect name="disabled" items={items} disabled={true} />
						</Col>
						<Col md={4}>
							<Label htmlFor="default">Preset</Label>
							<Multiselect name="preset" items={items} />
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default MultiselectDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/MultipleSelection/MultiselectDemo.js